import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import signin from "../../assets/img/signin.svg";
import loader from '../../assets/img/loader.gif';
import { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { verifyMobileSignup, verifyOtp } from '../../Redux/Auth';

const VerifyMobile = () => {

    const navigate = useNavigate();
    const [switchbutton, setSwitchbutton] = useState(false);
    const [isloader, setIsloader] = useState(false);

    const validationSchema = Yup.object().shape({
        phone: Yup.string().matches(/^[6-9]\d{9}$/, 'Enter a valid mobile number')
            .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            phone: "",
            type_of_user: "1",
        },
        validationSchema,
        onSubmit: (values) => {
            __formSubmit(values)
        },
    });
    const __formSubmit = (values) => {
        setIsloader(true)
        // formData.append("phone", values.phone);
        // formData.append("type_of_user", values.type_of_user);
        verifyMobileSignup(values.phone, values.type_of_user)((response) => {

            if (response && response.status) {
                localStorage.setItem('refresh_token', response.data.refresh);
                localStorage.setItem('token_temp', response.data.token);
                localStorage.setItem('user_type', response.data.user.type_of_user);
                localStorage.setItem('user_name', response.data.user.username);
                localStorage.setItem('user_id', response.data.user.id);
                setSwitchbutton(true);
                setIsloader(false)

            }
            else {

                // formikPhone.setErrors({
                //     phone: response?.response?.data?.data?.errors?.phone,
                //     type_of_user: response?.response?.data?.data?.errors?.type_of_user
                // })
                // setToaster("Invalid mobile")
                // setTimeout(() => {
                //     setToaster("")
                // }, 2000);
            }
        });
    };
    const __onVerifyOtp = (e) => {
        e.preventDefault();
        localStorage.setItem('token', localStorage.getItem('token_temp'))
        localStorage.removeItem('token_temp')
        setIsloader(true)
        verifyOtp(formik.values.otp)((response) => {
            if (response.status) {

                setIsloader(false)

                // setShowOtp(false)
                if (localStorage.getItem('user_type')) {
                    if (response?.data?.non_reviewd_task && response?.data?.non_reviewd_task[0]?.task_details)
                        localStorage.setItem('view_rating', true);
                    navigate("/", { state: { login: true, title: response?.data?.non_reviewd_task[0]?.title, task_details: response?.data?.non_reviewd_task[0]?.task_details } });
                }
                else {
                    // setToaster("Error")
                    // setTimeout(() => {
                    //     setToaster("")
                    // }, 2000);
                }


            }
            else {
                setIsloader(false)

                // setOtpError(response.response.data.message)
                // localStorage.setItem('token_temp', localStorage.getItem('token'))
                // localStorage.removeItem('token')
                // setToaster("Error")
                // setTimeout(() => {
                //     setToaster("")
                // }, 2000);
            }

        });

    }
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Verify Mobile Number </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Verify Mobile Number</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="signinpage">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <img src={signin} alt="" className="img-fluid" />
                        </div>
                        <div className="col-lg-6">
                            <div className="login-wrap">
                                <div className="login-html">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="signintitle">
                                                <h1>Verify Mobile Number</h1>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="login-form">
                                        <div className="verify-mob">
                                            <Form onSubmit={formik.handleSubmit}>
                                                {!switchbutton ?
                                                    <React.Fragment>
                                                        {/* <Form.Label>Select User <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                        <Form.Select name="type_of_user" className='mb-3' onChange={formikPhone.handleChange}>
                                                            <option value=''>Select User Type</option>
                                                            <option value={1}>Buyer</option>
                                                            <option value={2}>Seller</option>
                                                        </Form.Select> */}

                                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                                            <Form.Label>Mobile Number <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                            <Form.Control
                                                                name='phone'
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.phone && !formik.errors.phone}
                                                                isInvalid={!!formik.errors.phone}
                                                                placeholder='Enter Mobile Number'
                                                                required
                                                                type="number"
                                                                maxLength={10}
                                                                value={formik.values.phone}
                                                            />
                                                            <Form.Control.Feedback type="invalid">{formik.errors.phone}</Form.Control.Feedback>
                                                        </Form.Group>



                                                        <div className="group">
                                                            {isloader == true ?
                                                                <div className='loader'>
                                                                    <img src={loader} alt="" />
                                                                </div>
                                                                :
                                                                <Button type="submit" className="btn btn-primary next-btn mt-3 mb-3" >Submit </Button>
                                                            }
                                                        </div>
                                                    </React.Fragment>
                                                    :
                                                    <React.Fragment>
                                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                                            <Form.Label>Enter OTP <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                            <Form.Control
                                                                name='otp'
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.otp && !formik.errors.otp}
                                                                isInvalid={!!formik.errors.otp}
                                                                maxLength="255"
                                                                placeholder='Enter OTP'
                                                                required
                                                                value={formik.values.otp}
                                                            />
                                                            <Form.Control.Feedback type="invalid">{formik.errors.otp}</Form.Control.Feedback>
                                                        </Form.Group>

                                                        <div className="group">
                                                            <Button type="submit" className="btn btn-primary next-btn mt-3 mb-3" onClick={(e) => __onVerifyOtp(e)}>Verify</Button>
                                                        </div>


                                                    </React.Fragment>
                                                }


                                            </Form>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default VerifyMobile;